import React, {useState} from "react"

import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import Tabs from "@irati/ui/src/Tabs"
import {H1} from "@irati/ui/src/Typography"
import Invoices from "../../components/Billing/Invoices"
import CurrentPlan from "../../components/Billing/CurrentPlan"

interface Props extends InjectIntl {}

enum BILLING_TABS {
  CURRENT_PLAN = "currentPlan",
  NEW_PLAN = "chooseNewPlan",
  PAST_INVOICES = "pastInvoices"
}

const Billing: React.FC<Props> = (props) => {
  const [selectedKey, setSelectedKey] = useState<string>(BILLING_TABS.CURRENT_PLAN)

  const renewalAvailable = false

  const handleCallback = () => {
    setSelectedKey("chooseNewPlan")
  }

  const getTabs = () => {
    const allTabs = [
      {
        title: props.formatMessage({id: "admin.billing.tabs.currentPlan"}),
        key: BILLING_TABS.CURRENT_PLAN,
        component: <CurrentPlan onCallback={handleCallback} />
      },
      {
        title: props.formatMessage({id: "admin.billing.tabs.chooseNewPlan"}),
        key: BILLING_TABS.NEW_PLAN,
        component: <></>
      },
      {
        title: props.formatMessage({id: "admin.billing.tabs.pastInvoices"}),
        key: BILLING_TABS.PAST_INVOICES,
        component: <Invoices />
      }
    ]
    if (!renewalAvailable) {
      return allTabs.filter((tab) => tab.key !== BILLING_TABS.NEW_PLAN)
    }

    return allTabs
  }

  return (
    <>
      <H1 marginBottom={2}>
        <FormattedMessage id="admin.billing.tabs.title" />
      </H1>
      <Tabs
        id="adminBilling_currentPlan_tabs"
        addMarginTop
        unmountOnExit
        mountOnEnter
        onSelect={(value) => setSelectedKey(value)}
        activeKey={selectedKey}
        tabs={getTabs()} />
    </>
  )
}

export default injectIntl(Billing)
